import { useEffect } from 'react';

const APP_NAME =
  window.location.hostname === 'localhost' ? 'Agentica\u1D38' : 'Agentica';

export const useDocumentTitle = (subtitle: string) => {
  useEffect(() => {
    document.title = `${APP_NAME} | ${subtitle}`;
  }, [subtitle]);
};
